import { type ILatLng } from '@shared_types/global_types'
import { asArray } from '@shared_utils/array_utils'
import { DEGREE_SYMBOL } from '@utils/string_utils'
import { round } from 'lodash'
import type { LngLatLike } from 'mapbox-gl'

const toDmsString = (coordinate: number, withSeconds = true) => {
  const absolute = Math.abs(coordinate)
  const degrees = Math.floor(absolute)
  const minutesNotTruncated = (absolute - degrees) * 60
  const minutes = Math.floor(minutesNotTruncated)
  const seconds = round((minutesNotTruncated - minutes) * 60)
  if (withSeconds) {
    return degrees + `${DEGREE_SYMBOL} ` + minutes + '\' ' + seconds + '"'
  } else {
    return degrees + `${DEGREE_SYMBOL} ` + minutes + '\''
  }
}

export function getLatLngFromTrackPoints (trackPoints: Element[]) {
  return asArray(trackPoints).map(point => ({
    lat: Number(point.attributes[0].value),
    lng: Number(point.attributes[1].value)
  }))
}

export function toLatLng (val: LngLatLike) {
  if (Array.isArray(val)) {
    return { lat: +val[1], lng: +val[0] }
  } else if ('lat' in val && 'lon' in val) {
    return { lat: +(val as { lat: number }).lat, lng: +(val as { lon: number }).lon }
  } else if ('lat' in val && 'lng' in val) {
    return { lat: +(val as { lat: number }).lat, lng: +(val as { lng: number }).lng }
  } else {
    return { lat: 0, lng: 0 }
  }
}
export function positionToDmsStringWithCardinal (pos: ILatLng, withSeconds = true, joinWith = ' / ') {
  const latitude = toDmsString(pos.lat, withSeconds)
  const latitudeCardinal = pos.lat >= 0 ? 'N' : 'S'

  const longitude = toDmsString(pos.lng, withSeconds)
  const longitudeCardinal = pos.lng >= 0 ? 'E' : 'W'

  return latitude + ' ' + latitudeCardinal + joinWith + longitude + ' ' + longitudeCardinal
}
